<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Settings</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div v-if="verified == 'false'" class="alert alert-warning fade show" role="alert">
  <strong>Verify E-mail!</strong> Please verify your email using the link sent to your email. If you didn't recieve an email or your link is expired, <a href="#" @click="resendEmail" style="color: blue;"> please click here for a new one.</a>
</div>
<div class="alert alert-success alert-dismissible fade show" role="alert" hidden id="resend">
  <strong>A new verification email has been sent to you email!</strong>
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
			<div class="row">
				<div class="col-md-6">
					<div class="card card-primary card-outline">
						<div class="card-header">
      						<strong>Change Password</strong>
      						<button class="btn btn-primary" type="button" style="margin-left: 46%;" @click.prevent="formPwControl(false)">Make Changes</button>
      					</div>
						<div class="card-body">
							<form @submit.prevent="changePassword" @keydown="passwordForm.onKeydown($event)" role="form">
								<div :class="['form-group', errors.oldPassword ? 'has-error' : '']">
                        		<label>Enter Current Password</label>
                        		<input type="password" name="oldpassword" class="form-control disabledPwInitially" v-model="passwordForm.oldPassword" placeholder="Enter the Current Password" disabled>
                        		<span v-if="errors.oldPassword" :class="['badge bg-danger']">Enter the valid password.</span>
                        	</div>
                        	<div :class="['form-group', errors.password ? 'has-error' : '']">
                        		<label>New Password</label>
                        		<input type="password" name="newpassword" class="form-control disabledPwInitially" v-model="passwordForm.password" placeholder="Enter the New Password" disabled>
                        		<span v-if="errors.password" :class="['badge bg-danger']">{{errors.password[0]}}</span>
                        	</div>
                        	<div :class="['form-group', errors.password_confirmation ? 'has-error' : '']">
                        		<label>Confirm New Password</label>
                        		<input type="password" name="cnewpassword" v-model="passwordForm.password_confirmation" class="form-control disabledPwInitially" placeholder="Confirm New Password" disabled>
                        		<span v-if="errors.password_confirmation" :class="['badge bg-danger']">Enter a valid password.</span>
                        	</div>
                        	<div class="form-group">
                        		<button class="btn btn-primary" type="submit">Change</button>
                        	</div>
							</form>
						</div>
					</div>
				</div>
				
				<div class="col-md-6">
      		<div class="card">
      			<form @submit.prevent="addContact" @keydown="form.onKeydown($event)" role="form">
      				<div class="card-header">
      					<strong>Contact Information</strong>
      					<button class="btn btn-primary" type="button" style="margin-left: 43%;" @click.prevent="formControl(false)">Make Changes</button>
      				</div>
      				<div class="card-body">
      					<div :class="['form-group', errors.name ? 'has-error' : '']">
									<label for="nf-fname">Name</label>
									<input class="form-control disabledInitially" v-model="form.name" id="nf-fname" type="text" name="name" placeholder="Enter Your Name" disabled>
									<span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
								</div>
								<div :class="['form-group', errors.buyer_name ? 'has-error' : '']">
									<label for="nf-lname">Buyer Name</label>
									<input class="form-control disabledInitially" v-model="form.buyer_name" id="nf-lname" type="text" name="buyer_name" placeholder="Enter Your Buyer Name" disabled>
									<span v-if="errors.buyer_name" :class="['badge bg-danger']">Enter a valid Buyer name.</span>
								</div>
								<div :class="['form-group', errors.mobile ? 'has-error' : '']">
									<label for="number1">Number</label>
									<input class="form-control disabledInitially" v-model="form.mobile" id="number1" type="number" name="phone1" placeholder="Enter Primary Phone Number" min="1000000000" disabled>
									<span v-if="errors.mobile" :class="['badge bg-danger']">Enter a valid phone number.</span>
								</div>
								<div :class="['form-group', errors.email ? 'has-error' : '']">
									<label for="email">E-mail</label>
									<input class="form-control disabledInitially" v-model="form.email" id="email" type="email" name="email" placeholder="Enter Your E-mail" disabled>
									<span v-if="errors.email" :class="['badge bg-danger']">Enter a valid E-mail.</span>
								</div>
      					</div>
      					<div class="card-footer">
      						<button class="btn btn-sm btn-primary disabledInitially" type="submit" disabled> Save</button>
									<button class="btn btn-sm btn-danger disabledInitially" type="reset" disabled> Reset</button>
      					</div>
      			</form>
      			</div>
      		</div>
			</div>
			<!-- row end -->
   </section>
    <!-- /.content -->

<br>
      <br>
    
<!-- All VUE Parts end before this comment -->
    <!-- /.content -->


    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },
        
        created(){
        	this.getUser();
        	this.checkVerified();
        },
        
        data(){
        	return {
        		passwordForm: new Form({
        			user_id: this.$userId,
        			oldPassword: '',
        			password: '',
        			password_confirmation: ''
        		}),
        		
        		form: new Form({
    					user_id: this.$userId,
    					name: '',
    					buyer_name: '',
    					mobile: '',
    					email: ''
    				}), 
        		errors: [],
        		
        		verified: ''
        	}
        },
        
        methods: {
        	changePassword(){
        		this.passwordForm.post("/api/changePassword")
        		.then(response => {
        			if(response.data == 0){
        				toast.fire({
      		      	type: 'success',
                	title: 'Password Changed'
            		});
            		this.errors = []
            		this.formPwControl(true);
        			}
        			else{
        				toast.fire({
      		      	type: 'error',
                	title: 'Wrong Current Password'
            		});
            		this.errors = []
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},
        	
        	addContact(){
    				this.form.post('/api/addContactInfo')
    					.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Updation Complete'
            		});
            		$("meta[name='user-name']").remove();
            		$('head').append( '<meta name="user-name" content="'+this.form.name+'">' );
            		$("meta[name='user-email']").remove();
            		$('head').append( '<meta name="user-email" content="'+this.form.email+'">' );
            		$("meta[name='user-phone']").remove();
            		$('head').append( '<meta name="user-phone" content="'+this.form.mobile+'">' );
            		this.getUser();
            		this.formControl(true);
            		this.errors = [];
    				})
    				.catch((errors)=>{
            	toast.fire({
      	      	type: 'error',
              	title: 'Updation Failed'
            	});
            	this.errors = errors.response.data.errors;   
          	})
    			},
    			
    			getUser(url="/api/getContact"){
    				Vue.prototype.$name = document.querySelector("meta[name='user-name']").getAttribute('content');
						Vue.prototype.$userEmail = document.querySelector("meta[name='user-email']").getAttribute('content');
						Vue.prototype.$phone = document.querySelector("meta[name='user-phone']").getAttribute('content');
    				axios.post(url, {id: this.$userId})
    				.then(response =>{
    					this.form.fill(response.data);
    					this.form.name = this.$name;
    					this.form.email = this.$userEmail;
    					this.form.user_id = this.$userId;
    					this.form.mobile = this.$phone
    				})
    			},
    			
    			formControl(bool){
    				var inputs = document.getElementsByClassName("disabledInitially");
    				//console.log(inputs.length);
    				for(let input of inputs){
    					//console.log(input);
    					//console.log(inputs[input].disabled);
    					input.disabled = bool;
    				}
    			},
    			
    			formPwControl(bool){
    				var inputs = document.getElementsByClassName("disabledPwInitially");
    				//console.log(inputs.length);
    				for(let input of inputs){
    					//console.log(input);
    					//console.log(inputs[input].disabled);
    					input.disabled = bool;
    				}
    			},
    			
    			checkVerified(){
        		this.verified = this.$verified;
        	},
        	
        	resendEmail(){
        		axios.get("/api/email/resend")
        		.then(() => {
        			document.getElementById("resend").hidden = false;
        		})
        	}
        }
    }
</script>
